
import React, { useEffect, useRef, useState } from 'react';
import { fabric } from 'fabric';
import  rectangle from './utils/rectangle.png';
import  oval from './utils/oval.png';
import  line from './utils/line.png';
import  triangle from './utils/triangle.png';
import  zigzag from './utils/zigzag.png';
import  erase from './utils/erase.png';
import  text from './utils/text.png';
import  bold from './utils/bold.png';
import  italic from './utils/italic.png';
import save from './utils/save.png';
import image from './utils/image.png';
import bringtofront from './utils/bringtofront.png';

import Pdf from "react-to-pdf";

import  jsPDF from "jspdf";

import Button from '@material-ui/core/Button';


import {Filesystem, Directory} from '@capacitor/filesystem';
import * as htmlToImage from 'html-to-image';
import { Capacitor } from '@capacitor/core';


const CreateAssignment = () => {
const canvaswidth = window.innerWidth;

  const fabricRef = useRef(null);
  const canvasRef = useRef(null);
  const [compLeft, setCompLeft] = useState(0);
  const [compTop, setCompTop] = useState(0);

  const [canvasLength, setCanvasLength] = useState(1);	
  const [color, setColor] = useState('black');
  const [textInput, setTextInput] = useState('');
  const [fontSize, setFontSize] = useState(24);
  const [fontColor, setFontColor] = useState('#000000');
  const [fontStyle, setFontStyle] = useState('normal');
  const [fontWeight, setFontWeight] = useState('normal');


































  useEffect(() => {
    const canvas = new fabric.Canvas('fabric-canvas', {
      width: canvaswidth,
      height: (canvaswidth * (4/3) * canvasLength),
      backgroundColor: '#f5f5f5',
    });
    fabricRef.current = canvas;

    // Optional: auto-update toolbar when an object is selected
    canvas.on('selection:created', handleSelection);
    canvas.on('selection:updated', handleSelection);
    canvas.on('selection:cleared', () => setTextInput(''));

    return () => canvas.dispose();
  }, []);








const updateTextProps = () => {
    const obj = fabricRef.current.getActiveObject();
    if (obj && obj.isType('i-text')) {
      obj.set({
        text: textInput,
        fill: fontColor,
        fontSize,
        fontStyle,
        fontWeight,
      });
      fabricRef.current.renderAll();
    }
  };








 const handleSelection = () => {
    const obj = fabricRef.current.getActiveObject();
    if (obj && obj.isType('i-text')) {
      setTextInput(obj.text);
      setFontSize(obj.fontSize);
      setFontColor(obj.fill);
      setFontStyle(obj.fontStyle || 'normal');
      setFontWeight(obj.fontWeight || 'normal');
      
    }
  };


const handleStyle = async (e) => {
const obj = fabricRef.current.getActiveObject();
if(e.target.value=='normal') {
     await setFontStyle('normal');
      await setFontWeight('normal');
}
else if(e.target.value=='italic') {
      await setFontStyle('italic');
      await setFontWeight('normal');
}
else if(e.target.value=='bold') {
      await setFontStyle('normal');
      await setFontWeight('bold');
}
else if(e.target.value=='italic bold') {
      await setFontStyle('italic');
      await setFontWeight('bold');
}
};



  const addEditableText = () => {
    const text = new fabric.IText('Click to edit', {
      left: compLeft,
      top: compTop,
      fill: color,
      fontSize: fontSize,
      fontStyle,
      fontWeight,
      fontFamily: 'Arial',
    });
   if(compLeft>=canvaswidth) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
    fabricRef.current.add(text);
    fabricRef.current.setActiveObject(text);
    text.enterEditing();
    text.selectAll();
  };

  

























  const drawRectangle = () => {
    const rect = new fabric.Rect({
      left: compLeft,
      top: compTop,
      fill: color,
      width: 100,
      height: 100,
    });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
    fabricRef.current.add(rect);
  };

  const drawCircle = () => {
    const circle = new fabric.Circle({
      left: compLeft,
      top: compTop,
      radius: 50,
      fill: color,
    });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
       fabricRef.current.add(circle);
  };

const drawTriangle = () => {
  const triangle = new fabric.Triangle({
    left: compLeft,
      top: compTop,
	width: 100,
    height: 100,
    fill: color,
  });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
     fabricRef.current.add(triangle);
};

const drawEllipse = () => {
  const ellipse = new fabric.Ellipse({
	left: compLeft,
      top: compTop,
    rx: 80, // radius X (horizontal)
    ry: 40, // radius Y (vertical)
    fill: color,
    // stroke: 'black',
    // strokeWidth: 2,
  });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
     fabricRef.current.add(ellipse);
};

const drawPolygon = () => {
  const points = [
      { x: 100, y: 0 },
      { x: 200, y: 0 },
      { x: 250, y: 86 },
      { x: 200, y: 172 },
      { x: 100, y: 172 },
      { x: 50,  y: 86 },
    ];

   const polygon = new fabric.Polygon(points, {
    fill: color,
    stroke: 'black',
    strokeWidth: 2,
    left: 150,
    top: 100,
    selectable: true,
  });

  fabricRef.current.add(polygon);
};


  const drawLine = () => {
    const line = new fabric.Line([compLeft, compTop, 100, 20], {
      stroke: color,
      strokeWidth: 1,
    });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
       fabricRef.current.add(line);
  };


const enableFreeDraw = () => {
  const canvas = fabricRef.current;
  const isCurrentlyDrawing = canvas.isDrawingMode;

  canvas.isDrawingMode = !isCurrentlyDrawing;

  if (canvas.isDrawingMode) {
    canvas.selection = false;
    canvas.forEachObject(obj => obj.selectable = false);
    canvas.freeDrawingBrush.color = color; // 'black';
    canvas.freeDrawingBrush.width = 1;
  } else {
    canvas.selection = true;
    canvas.forEachObject(obj => obj.selectable = true);
  }
};


const writeCustomText = () => {
  if (!textInput.trim()) return;

  const text = new fabric.Text(textInput, {
	left: compLeft,
      top: compTop,
    fill: 'black',
    fontSize: 20,
  });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
     fabricRef.current.add(text);
};





 // Create a triangle using path
const createPath = () => {    
const pathData = 'M 100 100 L 200 100 L 150 200 Z';  // Move to, Line, Line, Close
    const path = new fabric.Path(pathData, {
      fill: color,
      stroke: 'blue',
      strokeWidth: 2,
      left: 50,
      top: 50,
    });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
     fabricRef.current.add(path);
};






 
const changeSelectedColor = (color) => {
  const canvas = fabricRef.current;
  const activeObject = canvas.getActiveObject();
  setColor(color);
  if (activeObject && activeObject.set && (activeObject.type=='line') ) {
    // Try to set fill color
    activeObject.set('stroke', color);
    canvas.renderAll();
  }
  else if (activeObject && activeObject.set && (activeObject.type!='line') ) {
    // Try to set fill color
    activeObject.set('fill', color);
    canvas.renderAll();
  }
 else {
    // alert('Please select an object first.');
  }
};


  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = function (f) {
      const data = f.target.result;
      fabric.Image.fromURL(data, (img) => {
        img.set({
left: 100+compLeft,
      top: 100+compTop,
          scaleX: 200 / img.width,
          scaleY: 200 / img.height,
        });
	if(compLeft>=(canvaswidth-40)) {
	setCompLeft(40);
	}
	else {
	setCompLeft(compLeft+20);
	}
	if(compTop>= 480) {
	setCompTop(40);
	}
	else {
	setCompTop(compTop+20);
	}
   
        fabricRef.current.add(img);
      });
    };
    reader.readAsDataURL(file);
  };



const bringToFront = () => {
  const canvas = fabricRef.current;
  const activeObject = canvas.getActiveObject();

  if (activeObject) {
    activeObject.bringToFront();
	canvas.renderAll();
  }
};




const deleteSelected = () => {
  const canvas = fabricRef.current;
  const activeObject = canvas.getActiveObject();

  if (activeObject) {
    canvas.remove(activeObject);
  }
};







 const saveCanvasAsJPG = () => {
   const canvas = fabricRef.current

    // Convert the canvas to a base64 string (JPG format)
    const dataUrl = canvas.toDataURL({
      format: 'jpeg',
      quality: 0.8, // Adjust quality as needed (1 is the highest quality)
    });

    // Create a temporary link element to download the image
    const link = document.createElement('a');
    link.href = dataUrl;
	var date = new Date();
    link.download = 'sgrd-stu-model-'+date.getYear()+'-'+date.getMonth()+'-'+date.getDay()+'-'+date.getHours()+'-'+date.getMinutes()+'-'+date.getSeconds()+'.jpg'; // Filename for the image
    link.click();
  };





let downloadfile = async () => {
var filepath="";
var img = null;
var filename=""+Date.now().toString()+".jpg";

if(Capacitor.getPlatform() === "android" || Capacitor.getPlatform() === "ios") {

if(window.confirm("Save File?")) {
await htmlToImage.toJpeg(document.getElementById('fabric-canvas'), { quality: 0.95 })
.then( async function(dataurl) {
await Filesystem.writeFile({ path: filename, data: dataurl, directory: Directory.Documents }).then((res) => { alert ("File Saved in "+res.uri); 
}, (err) => { alert(JSON.stringify(err)); } ) 
});
}
}
}





















  return (

     <div style = {{ position: "relative", top: '5px', left: '0vw' }} >
      <div style={{ marginBottom: 10 }}>
        <button onClick={drawRectangle}><img src={ rectangle } style = {{ width: '25px', height: '25px' }}/></button>
        <button onClick={drawCircle}><img src={ oval } style = {{ width: '25px', height: '25px' }}/></button>
	<button onClick={drawTriangle}><img src={ triangle } style = {{ width: '25px', height: '25px' }}/></button>
	{/* <button onClick={createPath}>Create Path</button> */}
	{/* <input type="text" placeholder="Enter text" onChange={(e) => setTextInput(e.target.value)} value={textInput} /> 
	<button onClick={writeCustomText}>Text</button> */}
        <button onClick={drawLine}><img src={ line } style = {{ width: '25px', height: '25px' }}/></button>
        <button onClick={enableFreeDraw}><img src={ zigzag } style = {{ width: '25px', height: '25px' }}/></button>
	<input type="color" onChange={(e) => changeSelectedColor(e.target.value)} />
	<button onClick={bringToFront}><img src={ bringtofront } style = {{ width: '25px', height: '25px' }}/></button>
       <button onClick={deleteSelected}><img src={ erase } style = {{ width: '25px', height: '25px' }}/></button>
	
<span style={{ border: '1px solid #888', borderRadius: '10%', backgroundColor: '#e6e6e6', width: '35px'}}>
<input type="file" name="inputimage" id="inputimage" accept=".jpg, .jpeg, .png" onChange={handleImageUpload} style = {{ display: "none" }} />
 <label for="inputimage" class="upload-label" >
<img src={ image } style = {{ width: '35px', height: '30px' }} />
  </label>
  </span>
        { (Capacitor.getPlatform() === "android" || Capacitor.getPlatform() === "ios") ?  (<button id="appdownload" style={{border: '1px solid #aaa', left:"25%"}} onClick={() => downloadfile()}><img src={ save } style = {{ width: '25px', height: '25px' }}/></button>) :
	(<button onClick={saveCanvasAsJPG}><img src={ save } style = {{ width: '25px', height: '25px' }}/></button>) }

        
      
        
      </div>





























<div>

<div style={{ marginBottom: '5px' }}>
        <button onClick={addEditableText}><img src={ text } style = {{ width: '25px', height: '25px' }}/></button>
         <input type="hidden" placeholder="Update text" value={textInput} onChange={(e) => setTextInput(e.target.value)} style={{ marginLeft: '10px', width:'200px' }} />
 {/* <input type="color" value={fontColor} onChange={(e) => changeSelectedColor(e.target.value)} /> */}

        <select value={fontSize} onChange={(e) => setFontSize(parseInt(e.target.value))} >
          {[10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34].map(size => (
            <option key={size} value={size}>{size}px</option>
          ))}
        </select>
        <select onChange={(e) => handleStyle(e)}>
          <option value="normal">Normal</option>
          <option value="italic">Italic</option>
          <option value="bold">Bold</option>
          <option value="italic bold">Italic Bold</option>
        </select>
{/*
        <select value={fontWeight} onChange={(e) => setFontWeight(e.target.value)}>
          <option value="normal">Normal</option>
          <option value="bold">Bold</option>
        </select>
*/}
        <button onClick={updateTextProps}>Apply</button>
      </div>

</div>



































<div id="canvas-div" style= {{  width: '98vw', height: '66vh',  overflow: 'auto' }}>
      <canvas id="fabric-canvas" ref={canvasRef} style={{ border: '1px solid #ccc' }} />
</div>
    </div>
  );
};

export default CreateAssignment;

